import React, { createContext, useContext } from "react";
import { useParams } from "react-router-dom";
import { useGetDossierByIdQuery } from "actions/dossiers/queries";

const DossierRoleContext = createContext({
  role: null,
  isLecteur: false,
  isCommercial: false,
  isAdmin: true,
  canEdit: true,
});

/**
 * Expose le rôle de l'utilisateur courant sur le dossier ouvert.
 *
 * - canEdit === false pour le rôle LECTEUR : toutes les pages doivent masquer
 *   ou désactiver leurs boutons d'action (créer, modifier, supprimer, importer).
 * - Le backend refuse déjà les écritures LECTEUR (403) ; ce contexte évite
 *   d'afficher des actions qui échoueraient.
 */
export const DossierRoleProvider = ({ children }) => {
  const { clientID: dossier_id } = useParams();
  const { data: dossier } = useGetDossierByIdQuery(
    { id: dossier_id },
    { skip: !dossier_id }
  );
  const role = dossier?.user_role || null;

  const value = {
    role,
    isLecteur: role === "LECTEUR",
    isCommercial: role === "COMMERCIAL",
    isAdmin: !role || role === "ADMIN",
    // Tant que le rôle n'est pas chargé, on n'affiche pas les actions
    // pour éviter un flash de boutons chez un LECTEUR.
    canEdit: Boolean(role) && role !== "LECTEUR",
  };

  return (
    <DossierRoleContext.Provider value={value}>
      {children}
    </DossierRoleContext.Provider>
  );
};

export const useDossierRole = () => useContext(DossierRoleContext);
